import { TRANSLATIONS } from "./countryInfo";

export const getCountryData = (langCode: string) => {
  const delimiter = langCode.includes("-") ? "-" : "_";
  const language = langCode?.split(delimiter)[0];
  return TRANSLATIONS.find((lng) => {
    return lng.code === language;
  });
};

/**
 * Country codes supported by react-flagkit v2.0.4.
 * Notable missing codes: AZ (Azerbaijan), BQ (Bonaire).
 * When a code isn't in this set, use getCountryFlagEmoji() as fallback.
 */
export const FLAGKIT_SUPPORTED = new Set([
  "AD","AE","AF","AG","AI","AL","AM","AO","AR","AS","AT","AU","AW","AX",
  "BA","BB","BD","BE","BF","BG","BH","BI","BJ","BL","BM","BN","BO","BR",
  "BS","BT","BV","BW","BY","BZ","CA","CC","CD","CF","CG","CH","CI","CK",
  "CL","CM","CN","CO","CR","CU","CV","CW","CX","CY","CZ","DE","DJ","DK",
  "DM","DO","DZ","EC","EE","EG","ER","ES","ET","EU","FI","FJ","FK","FM",
  "FO","FR","GA","GB","GD","GE","GF","GG","GH","GI","GL","GM","GN","GP",
  "GQ","GR","GS","GT","GU","GW","GY","HK","HM","HN","HR","HT","HU","ID",
  "IE","IL","IM","IN","IO","IQ","IR","IS","IT","JE","JM","JO","JP","KE",
  "KG","KH","KI","KM","KN","KP","KR","KW","KY","KZ","LA","LB","LC","LI",
  "LK","LR","LS","LT","LU","LV","LY","MA","MC","MD","ME","MG","MH","MK",
  "ML","MM","MN","MO","MP","MQ","MR","MS","MT","MU","MV","MW","MX","MY",
  "MZ","NA","NC","NE","NF","NG","NI","NL","NO","NP","NR","NU","NZ","OM",
  "PA","PE","PF","PG","PH","PK","PL","PM","PN","PR","PS","PT","PW","PY",
  "QA","RE","RO","RS","RU","RW","SA","SB","SC","SD","SE","SG","SI","SJ",
  "SK","SL","SM","SN","SO","SR","SS","ST","SV","SX","SY","SZ","TC","TD",
  "TF","TG","TH","TJ","TK","TL","TM","TN","TO","TR","TT","TV","TW","TZ",
  "UA","UG","UM","US","UY","UZ","VA","VC","VE","VG","VI","VN","VU","WF",
  "WS","XK","YE","YT","ZA","ZM","ZW"
]);

/**
 * Generates a flag emoji from a 2-letter ISO 3166-1 country code.
 * Used as fallback when react-flagkit doesn't support a country code.
 */
export const getCountryFlagEmoji = (countryCode: string) =>
  String.fromCodePoint(
    ...[...countryCode.toUpperCase()].map((x) => 0x1f1a5 + x.charCodeAt(0))
  );
